import React, { useState } from 'react';
import { getRandomImage } from '../../hooks';

export const CreatePathwayItem = ({ data, index }) => {
  const [optionsVisible, setOptionsVisible] = useState(false);
  const url = `/courses/${data?.course_id}`


  // const [edxData, duration, shortDescription] = data._source.course_info
  //   .edx_data
  //   ? (() => {
  //     const parsedData = JSON.parse(data._source.course_info.edx_data);
  //     return [
  //       parsedData,
  //       parsedData?.duration,
  //       parsedData?.short_description,
  //     ];
  //   })()
  //   : ['', ''];
  // const [level] = data._source.data
  //   ? (() => {
  //     const parsedData = JSON.parse(data._source.data);
  //     return [parsedData?.level];
  //   })()
  //   : ['', ''];

  const toggleOptions = () => {
    setOptionsVisible(!optionsVisible);
  };

  const hideOptions = () => {
    setOptionsVisible(false);
  };

  const handleRemoveItemClick = () => {};
  return (
    <>
      <div className="units_block mgt30">
        <div className="unit_num">
          <div className="number">
            <div className="l_bel"></div>
            <div className="div-block-72">
              <div className="div-block-70">
                <img
                  alt=""
                  className="image-46"
                  loading="lazy"
                  src="/images/62a334c5a2b21b82f0ac43fc_hexagon_162a334c5a2b21b82f0ac43fc_hexagon.png"
                />
                <div className="num reg">{index + 1}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="unit_listing path">
          <div className="course-rec-3-wide">
            <a className="course_link_wide w-inline-block" href={url}>
              <div className="course-header-rec-3-wide">
                <img
                  alt=""
                  className="image-34-wide"
                  height={30}
                  src={getRandomImage()}
                />
                <div className="unit_type_div w-clearfix">
                  <img
                    alt=""
                    className="type_img"
                    loading="lazy"
                    src="/images/play-button_2play-button.png"
                  />
                  <div className="text-block-52">
                    Course
                  </div>
                </div>
              </div>
              <div className="course-body-4-wide">
                <div className="unit-wide-header-holder">
                  <div className="text-block-39 wide">
                    {data?.name}
                    <br />
                  </div>
                  <div className="div-block-23 p">
                    <div className="div-block-24">
                      <img
                        alt=""
                        className="image-18"
                        loading="lazy"
                        sizes="100vw"
                        src="images/google.png"
                        srcSet="images/google-p-500.png 500w, images/google.png 512w"
                      />
                    </div>
                    <div className="text-block-16 p">Google</div>
                  </div>
                  <div className="unit-wide-description">
                  </div>
                </div>
                <div className="line4 n t"></div>
                <div className="course-features">
                  <div className="div-block-74 first_row wide">

                    <div className="div-block-73 wide mg-lauto">
                      {/* <div
                        className="faq-wrap-3 c-trigger"
                        onClick={toggleOptions}
                      >
                        <img
                          src="/images/menu_1menu.png"
                          alt=""
                          className="img-trg-4"
                        />
                      </div> */}
                      {optionsVisible && (
                        <div
                          className="options_div cr-pathway active"
                          onBlur={hideOptions}
                        >
                          <div
                            className="text-block-103 remove_item"
                            onClick={handleRemoveItemClick}
                          >
                            Remove
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
